import React from 'react';

import { TableComponent, connect } from "src/components/tableComponent";
import config from 'src/config';
import moment from 'moment';

class Component extends TableComponent {

  initialState = {
    from: moment().subtract(1, 'week'),
    to: moment().add(1, 'day'),
    type: "all",
    only_sales: true,
    expand: true,
    copied: false
  }

  getInitialState = (initialState)=> {
    if (this.props.user.role_id >= 3) {
      initialState.expand = false
      initialState.only_sales = true
      // initialState.from = moment().subtract(1, 'month')
      initialState.from = moment().isoWeekday(1);
    } else {
      initialState.expand = true
      initialState.only_sales = false
      initialState.from = moment().isoWeekday(1);
    }
    return initialState
  }

  makeColumns = () => {
    let columns = [
      {
        Header: "date",
        id: "date",
        // accessor: d => moment(d.days * 1000*60*60*24).format("DD MMM YYYY"),
        accessor: d => moment(d.click_date*1000).format("DD MMM YYYY"),
        minWidth: 100,
      }, {
        Header: "unique visits",
        accessor: "unique_visits",
        minWidth: 180,
      }, {
        Header: "sales",
        accessor: "sales",
        minWidth: 130,
      }
    ]
    if (this.props.user.autologin == 1) {
      columns.splice(1,0,{
        Header: "visits",
        accessor: "visits",
        minWidth: 150,
      })
    }
    return columns; 
  }

  apiPath = "links/stats"

  tableParams = {
    manual: true,
    sorted: [{
      id: "date",
      desc: true
    }]    
  }

  fetchParams = () => {
    return {
      linkId: this.props.match.params.linkId
    }
  }

  render() {
    return (
      <div>
        {!this.props.state.initial && false &&        
        <div class="row">
          <div class="col-10 text-center">
            <div class="pull-left mr-2">
              {this.datepickerElement()}
            </div>
          </div>
        </div>
        }
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2 text-center">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"links_stats")